import React from "react";
import "./Welcomepage.css";
import { Link, useNavigate } from "react-router-dom";
import CommanButton from "../CommanComponent/CommanButton/CommanButton";
const Welcomepage = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="welcome-page">
        <div className="video-main">
          <div className="main-row-secccc">
            <div className="row me-0 ms-0 main-row">
              <div className="col-md-6 col-sm-6 col-12 px-0 partation-holder">
                <div className="overflow-content">
                  <div className="custom_container">
                    <div className="logo">
                      <Link to="/home">
                        <img
                          className="headlogo"
                          src={"/assets/images/logo/logo.png"}
                          alt="Mittal Craftworks"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="videodesktop landing_img_holder">
                  <img
                    className="landing_img"
                    src={"/assets/images/bg-themes/bg2.jpg"}
                    alt="Luxury Gifts"
                  />
                </div>
                <div className="content-holder">
                  <div className="heading-text text-center">
                    <h2>LILA KAUMODAKI MFG</h2>
                    <div className="button-holder">
                      <CommanButton
                        to="/home"
                        onClick={() => {
                          navigate("/home");
                        }}
                        text="EXPLORE"
                        className="explore-btn"
                      />
                    </div>

                    <div className="text-holder"></div>

                    <div className="overlay-text-color1"></div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-sm-6 col-12 px-0 partation-holder">
                <div className="overflow-content">
                  <div className="custom_container">
                    <div className="logo">
                      <Link to="/new/home">
                        <img
                          className="headlogo"
                          src={"/assets/images/logo/logo.webp"}
                          alt="Mittal Craftworks"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="videodesktop landing_img_holder">
                  <img
                    className="landing_img"
                    src={"/assets/images/bg-themes/LK_web1_BG.png"}
                    alt="Corporate Gifts"
                  />
                </div>

                <div className="content-holder">
                  <div className="heading-text text-center">
                    <h2>KAUMODAKI INTERNATIONAL PVT LTD</h2>

                    <div className="button-holder">
                      <CommanButton
                        to="/new/home"
                        onClick={() => {
                          navigate("/new/home");
                        }}
                        text="EXPLORE"
                        className="explore-btn"
                      />
                    </div>

                    <div className="text-holder"></div>

                    <div className="overlay-text-color1"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ================= LOGO ================= */}
      </section>
    </>
  );
};

export default Welcomepage;
